export function safeText(val: unknown, fallback = "—"): string {
  if (val === null || val === undefined || val === "") return fallback;
  return String(val);
}
export function safeNumber(val: unknown, fallback = 0): number {
  const n = Number(val);
  return isNaN(n) ? fallback : n;
}
export function safeArray<T>(val: unknown): T[] {
  return Array.isArray(val) ? val : [];
}
